var utils = require('utils');

var Point = function (x, y) {
  var pair = Point.getFromArgs(arguments);
  this[0] = pair[0];
  this[1] = pair[1];
}

var PointPrototype = {
  add: function () {
    var pair = getPointFromArgs(arguments);
    return new Point(this[0]+pair[0], this[1]+pair[1]);
  },
  rotate: function (angle, pivot) {
    return new Point(utils.coordRotate(this,angle,pivot));
  }
}

Point = utils.inherit(Array, Point, PointPrototype);

Point.getFromArgs = function (args) {
  if(args.length<1)return [0,0];
  if(args[0].length) return utils.coordPair(args[0]);
  else return utils.coordPair([args[0], args[1]]);
}

module.exports = Point;